var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-bar-chart__bar",class:{'simple-bar-chart__bar--empty': _vm.width === 0},style:({'background-color': _vm.barColor, width: _vm.width + '%' })})
}
var staticRenderFns = []

export { render, staticRenderFns }